import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, unref as _unref, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "block w-full" }
const _hoisted_2 = { class: "grid grid-cols-2 gap-4 w-full" }
const _hoisted_3 = { class: "inputTitle" }
const _hoisted_4 = { class: "inputField flex-grow" }
const _hoisted_5 = { class: "error-msg" }
const _hoisted_6 = { class: "inputTitle" }
const _hoisted_7 = { class: "inputField flex-grow" }

import {computed, onMounted, ref, toRef} from "vue";
import Text from "@/components/inputs/Text";
import {helpers, required} from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import {useGlobalStore} from "@/stores/GlobalStore";
import {useI18n} from "vue-i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'Group1Popup',
  props: {
    data: Object
},
  setup(__props) {

const globalStore = useGlobalStore();
const { t } = useI18n();
const props = __props;
const popupData = toRef(props, 'data');


const rules = computed(() => {

	const rules = {
		name: { required: helpers.withMessage(t('validators.required'), required), },
	}
	return rules
})

const v$ = ref(useVuelidate(rules, popupData))

onMounted(() => {
	globalStore.modal.validator = v$;
})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('popups.group1.name')) + " * ", 1),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", {
              class: _normalizeClass({ error: v$.value.name.$errors.length })
            }, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((popupData.value.name) = $event)),
                class: "w-full"
              }, null, 512), [
                [_vModelText, popupData.value.name]
              ]),
              _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v$.value.name.$errors, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "input-errors",
                  key: error.$uid
                }, [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(error.$message), 1)
                ]))
              }), 128))
            ], 2)
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('popups.group1.syncId')), 1),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_unref(Text), {
              modelValue: popupData.value.syncId,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((popupData.value.syncId) = $event))
            }, null, 8, ["modelValue"])
          ])
        ])
      ])
    ])
  ]))
}
}

})